var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-dialog",
    { ref: "base" },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [
            _vm._v(' Закупка "' + _vm._s(_vm.purchase.title) + '" '),
          ]),
          _c("v-card-subtitle", [
            _vm._v(" Перерасчет процента заказов закупки "),
          ]),
          _c(
            "v-card-text",
            [
              _c("v-text-field", {
                directives: [{ name: "only-number", rawName: "v-only-number" }],
                staticClass: "mt-1",
                attrs: {
                  "hide-details": "",
                  disabled: _vm.loading_recalculation,
                  dense: "",
                  outlined: "",
                  label: "Новый процент",
                },
                model: {
                  value: _vm.data.percent,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "percent", _vm._n($$v))
                  },
                  expression: "data.percent",
                },
              }),
            ],
            1
          ),
          _c("v-card-title", [_vm._v(" Параметры ")]),
          _c(
            "v-card-text",
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  inset: "",
                  label: "Обновить процент заказов у альбомов",
                },
                model: {
                  value: _vm.data.need_update_orders,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "need_update_orders", $$v)
                  },
                  expression: "data.need_update_orders",
                },
              }),
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  inset: "",
                  label: "Не учитывать заказы с предоплатой поставщику",
                },
                model: {
                  value: _vm.data.ignore_prepaid_orders,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "ignore_prepaid_orders", $$v)
                  },
                  expression: "data.ignore_prepaid_orders",
                },
              }),
              _c("div", { staticClass: "subtitle-2 mb-2" }, [
                _vm._v(" Выбрать альбомы "),
              ]),
              _c("v-select", {
                staticClass: "mb-2",
                attrs: {
                  "hide-details": "",
                  dense: "",
                  outlined: "",
                  label: "У которых",
                  items: _vm.type_items,
                },
                model: {
                  value: _vm.data.album_type,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "album_type", $$v)
                  },
                  expression: "data.album_type",
                },
              }),
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "py-0 pl-0 pr-1", attrs: { cols: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              disabled: _vm.data.album_type === null,
                              label: "Условие",
                              items: _vm.condition_items,
                            },
                            model: {
                              value: _vm.data.album_condition,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "album_condition", $$v)
                              },
                              expression: "data.album_condition",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "py-0 pr-0 pl-1", attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "only-number",
                                rawName: "v-only-number.float",
                                modifiers: { float: true },
                              },
                            ],
                            attrs: {
                              disabled: _vm.data.album_condition === null,
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              label: "Сумма",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "append",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticStyle: { "font-size": "25px" } },
                                      [_vm._v("₽")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.data.album_value,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "album_value", _vm._n($$v))
                              },
                              expression: "data.album_value",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-container",
                { staticClass: "py-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pb-1 pt-2 text-right",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-h mr-1",
                              attrs: { disabled: _vm.loading_recalculation },
                              on: {
                                click: function ($event) {
                                  return _vm.$refs.base.hide()
                                },
                              },
                            },
                            [_vm._v(" Отмена ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn btn-h",
                              attrs: {
                                color: "primary",
                                loading: _vm.loading_recalculation,
                              },
                              on: { click: _vm.onRecalculationPercent },
                            },
                            [_vm._v("Пересчитать ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }